import {
  createAction,
  props
} from '@ngrx/store';

import { SchuecoProductValidationResponseInterface } from '@p1/libs/schueco-product-validation/src/lib/model/schueco-product-validation-response.interface';


export const serviceStatusRequested = createAction(
  '[ProductValidation] Service alive status requested',
  props<{alive}>()
);

export const checkIfValidationIsPossible = createAction(
  '[ProductValidation] Check if product is configurable',
  props<{productUuid}>()
);

export const checkIfValidationIsPossibleSuccess = createAction(
  '[ProductValidation] Check if product is configurable success',
  props<{isPossible}>()
);

export const checkIfValidationIsPossibleFailure = createAction(
  '[ProductValidation] Check if product is configurable failure',
  props<{error: any}>()
);

export const productValidationTriggered = createAction(
  '[ProductValidation] Product validation triggered',
  props<{productUuid: string}>()
);

export const productValidationTriggeredSuccess = createAction(
  '[ProductValidation] Product validation triggered success',
  props<{validationUuid: string; queryUuid?: string}>()
);

export const productValidationTriggeredFailure = createAction(
  '[ProductValidation] Product validation triggered failure',
  props<{error: any}>()
);

export const fetchProductValidationTriggered = createAction(
  '[ProductValidation] Fetch product validation triggered',
  props<{validationUuid: string}>()
);

export const fetchProductValidationTriggeredSuccess = createAction(
  '[ProductValidation] Fetch product validation triggered success',
  props<{validationUuid: string; validationResult: SchuecoProductValidationResponseInterface}>()
);

export const fetchProductValidationTriggeredFailure = createAction(
  '[ProductValidation] Fetch product validation triggered failure',
  props<{error: any}>()
);

export const validationConfigurationOpened = createAction(
  '[ProductValidation] Validation configuration opened',
  props<{productUuid: string}>()
);

export const configOptionsRequestedSuccess = createAction(
  '[ProductValidation] Config options requested success',
  props<{configOptions}>()
);

export const configOptionsRequestedFailure = createAction(
  '[ProductValidation] Config options requested failure',
  props<{error: any}>()
);

// workaround to be able to listen to actions in other modules
// https://timdeschryver.dev/blog/ngrx-creator-functions-101
export type Actions = ReturnType<typeof fetchProductValidationTriggeredSuccess> | ReturnType<typeof fetchProductValidationTriggered>;
